/* Méga-menu marchand PK (base Dawn).
   1) Ouverture au survol (desktop) pilotée par COORDONNÉES : le menu reste ouvert
      tant que le curseur est dans la zone utile (entrée + panneau + l'espace entre
      les deux), quel que soit l'élément au-dessus. Indispensable ici : un overlay
      tiers résiduel (Klaviyo, kl-private-*) couvre l'espace sous l'entrée et
      intercepterait un simple mouseleave, refermant le menu pendant la descente.
   2) Permutation des jeux de cartes produits au survol des sous-catégories.
   Vanilla JS, sans dépendance. */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px) and (hover: hover)');

  /* ------------------------------------------------------------------ */
  /* 1. Ouverture au survol (par coordonnées)                            */
  /* ------------------------------------------------------------------ */
  function initHoverOpen() {
    var menus = [];
    var all = document.querySelectorAll('header-menu');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('details.mega-menu')) menus.push(all[i]);
    }
    if (!menus.length) return;

    var openMenu = null;
    var closeTimer = null;

    function detailsOf(m) { return m.querySelector('details.mega-menu'); }

    function openOnly(menu) {
      for (var j = 0; j < menus.length; j++) {
        var d = detailsOf(menus[j]);
        if (d && menus[j] !== menu && d.open) d.open = false;
      }
      var dm = detailsOf(menu);
      if (dm && !dm.open) dm.open = true;
      openMenu = menu;
    }

    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    function scheduleClose() {
      if (closeTimer || !openMenu) return;
      closeTimer = setTimeout(function () {
        closeTimer = null;
        if (!openMenu) return;
        var d = detailsOf(openMenu);
        // ne pas fermer si le focus clavier est resté dans le menu
        if (d && d.contains(document.activeElement)) return;
        if (d) d.open = false;
        openMenu = null;
      }, 180);
    }

    // Zone sûre = entrée (summary) + panneau (content) + la bande qui les relie.
    function inSafeZone(x, y, menu) {
      var s = menu.querySelector('summary').getBoundingClientRect();
      var c = menu.querySelector('.mega-menu__content').getBoundingClientRect();
      var inSummary = x >= s.left - 8 && x <= s.right + 8 && y >= s.top - 6 && y <= s.bottom + 2;
      var inContent = x >= c.left && x <= c.right && y >= c.top - 2 && y <= c.bottom + 2;
      // le "pont" : toute la largeur du panneau, entre le bas de l'entrée et le haut du panneau
      var inGap = x >= c.left && x <= c.right && y > s.bottom - 2 && y < c.top + 2;
      return inSummary || inContent || inGap;
    }

    for (var k = 0; k < menus.length; k++) {
      (function (menu) {
        var summary = menu.querySelector('summary');
        summary.addEventListener('mouseenter', function () {
          if (!DESKTOP.matches) return;
          cancelClose();
          openOnly(menu);
        });
      })(menus[k]);
    }

    document.addEventListener('mousemove', function (e) {
      if (!DESKTOP.matches || !openMenu) return;
      if (inSafeZone(e.clientX, e.clientY, openMenu)) {
        cancelClose();
      } else {
        scheduleClose();
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Permutation des jeux de cartes produits                          */
  /* ------------------------------------------------------------------ */
  function swapTo(pane, set) {
    var grids = pane.querySelectorAll('.pk-mega__products-grid');
    for (var i = 0; i < grids.length; i++) {
      var match = grids[i].getAttribute('data-pk-set') === set;
      grids[i].classList.toggle('pk-mega__products-grid--hidden', !match);
      grids[i].setAttribute('aria-hidden', match ? 'false' : 'true');
    }
  }

  /* Jeux charges a la demande (entrees de 3e niveau, marquees data-pk-lazy).
     Pourquoi : rendre les 21 animaux en statique ajoutait 84 cartes a 1 807 octets,
     soit 148 Ko sur CHAQUE page du site, mobile compris ou le menu ne s'ouvre jamais
     (mesure du 04/08 : le header pese 179 Ko dont 67 % de cartes deja).
     Ici le cout des pages est nul, et chaque animal n'est demande qu'une fois. */
  var enCache = {};
  var dernierDemande = null;

  function chargerPuisAfficher(pane, link, set) {
    // Deja dans la page (2e niveau, ou 3e niveau deja charge) : permutation immediate.
    if (pane.querySelector('.pk-mega__products-grid[data-pk-set="' + set + '"]')) {
      swapTo(pane, set);
      return;
    }
    if (enCache[set] === 'encours' || enCache[set] === 'echec') return;
    enCache[set] = 'encours';

    /* Mesure du 04/08 : la requete met 440 a 500 ms sur une preview, qui n'est JAMAIS
       en cache CDN. Sans signal, la zone parait figee pendant ce temps. On attenue au
       lieu de vider : les cartes precedentes restent lisibles, il n'y a pas de saut. */
    pane.classList.add('pk-mega__products--charge');
    var finCharge = function () { pane.classList.remove('pk-mega__products--charge'); };

    var url = link.href + (link.href.indexOf('?') > -1 ? '&' : '?') + 'view=mega';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
      .then(function (html) {
        if (!html.trim()) throw new Error('vide');
        var grille = document.createElement('div');
        grille.className = 'pk-mega__products-grid pk-mega__products-grid--hidden';
        grille.setAttribute('data-pk-set', set);
        grille.setAttribute('aria-hidden', 'true');
        grille.innerHTML = html;
        pane.appendChild(grille);
        enCache[set] = 'ok';
        finCharge();
        // Le curseur a pu partir ailleurs pendant la requete : ne pas afficher les
        // produits d'une entree qu'on ne survole plus.
        if (dernierDemande === set) swapTo(pane, set);
      })
      .catch(function () {
        // Echec silencieux : les cartes par defaut restent affichees, le menu marche.
        enCache[set] = 'echec';
        finCharge();
      });
  }

  function initSwap() {
    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      var link = e.target.closest('.mega-menu__link[data-pk-set]');
      if (!link) return;
      var content = link.closest('.mega-menu__content');
      if (!content) return;
      var pane = content.querySelector('.pk-mega__products');
      if (!pane) return;
      var set = link.getAttribute('data-pk-set');
      dernierDemande = set;
      if (link.hasAttribute('data-pk-lazy')) chargerPuisAfficher(pane, link, set);
      else swapTo(pane, set);
    });

    /* Sortie du bloc de nav : retour aux produits de la collection parente */
    document.addEventListener('mouseout', function (e) {
      if (!e.target || !e.target.closest) return;
      var content = e.target.closest('.mega-menu__content');
      if (!content) return;
      if (e.relatedTarget && content.contains(e.relatedTarget)) return;
      // Remis AVANT le swap : une requete encore en vol ne doit pas afficher, en
      // retard, les produits d'une entree que le curseur a deja quittee.
      dernierDemande = 'default';
      var pane = content.querySelector('.pk-mega__products');
      if (pane) swapTo(pane, 'default');
    });
  }

  function init() {
    initHoverOpen();
    initSwap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
